<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M9.56 7.44a1.5 1.5 0 10-2.12 2.12L21.878 24 7.439 38.44a1.5 1.5 0 002.122 2.12l15.5-15.5a1.5 1.5 0 000-2.12L9.56 7.44zm18.5 0a1.5 1.5 0 00-2.12 2.12L40.378 24l-14.44 14.44a1.5 1.5 0 002.122 2.12l15.5-15.5a1.5 1.5 0 000-2.12l-15.5-15.5z"/></svg>